import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { PlanogramComponent } from './pages/planogram/planogram.component';
import { AuthorizedGuard } from './guards/authorized.guard';
import { NewPlanogramComponent } from './pages/new-planogram/new-planogram.component';
import { BulkCloneComponent } from './pages/bulk-clone/bulk-clone.component';
import { ExternalHomeComponent } from './pages/external-home/external-home.component';
import { ExternalGuard } from './guards/external.guard';
import { NotificationsPageComponent } from './pages/notifications/notifications.component';
import { SharingCenterComponent } from './pages/sharing-center/sharing-center.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthorizedGuard, ExternalGuard],
  },
  {
    path: 'folder/:folderId',
    component: HomeComponent,
    canActivate: [AuthorizedGuard, ExternalGuard],
  },
  {
    path: 'external',
    component: ExternalHomeComponent,
    canActivate: [AuthorizedGuard],
  },
  { path: 'login', component: LoginComponent },
  {
    path: 'planogram/:id',
    component: PlanogramComponent,
    canActivate: [AuthorizedGuard],
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'planogram/:id/:stateId',
    component: PlanogramComponent,
    canActivate: [AuthorizedGuard],
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'create-planogram',
    component: NewPlanogramComponent,
    canActivate: [AuthorizedGuard, ExternalGuard],
  },
  {
    path: 'bulk-clone',
    component: BulkCloneComponent,
    canActivate: [AuthorizedGuard, ExternalGuard],
  },
  {
    path: 'sharing-center',
    component: SharingCenterComponent,
    canActivate: [AuthorizedGuard, ExternalGuard],
  },
  {
    path: 'notifications',
    component: NotificationsPageComponent,
    canActivate: [AuthorizedGuard],
  },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}

